var map = {
	"./1980-mobile2.jpg": "fb00",
	"./1980pages-mobile.jpg": "a6e4",
	"./2000-WEB.jpg": "bedd",
	"./2000-betting.jpg": "cdff",
	"./2000-mobile.jpg": "900a",
	"./2000otherpages.jpg": "25d3",
	"./Mobile-1980.jpg": "3e4e",
	"./Web-1980.jpg": "c82e",
	"./aj-1980-new.jpg": "78b2",
	"./aj-1980web.jpg": "bcff",
	"./aj-2000-mobile.jpg": "6d8c",
	"./aj-2000-web.jpg": "381f",
	"./aj-2000bet-web.jpg": "ad38",
	"./aj-aibo.jpg": "0351",
	"./aj-ajold.jpg": "da98",
	"./aj-claytonacres.jpg": "e894",
	"./aj-design.jpg": "d0a3",
	"./aj-fftp.jpg": "e35c",
	"./aj-resolutelab.jpg": "1422",
	"./ayos-logo.png": "9c45",
	"./ayosjuan-logo.png": "20a7",
	"./bg-pattern.png": "f356",
	"./bg.jpg": "3625",
	"./bg1.jpg": "9970",
	"./bohu-index.jpg": "c5f4",
	"./contactbg.jpg": "5dfe",
	"./dp.jpg": "a28e",
	"./image_1.jpg": "8825",
	"./image_2.jpg": "1d79",
	"./image_3.jpg": "a3bd",
	"./image_4.jpg": "9ac7",
	"./image_5.jpg": "ebc7",
	"./image_6.jpg": "0e63",
	"./image_7.jpg": "f868",
	"./portfolio.jpg": "7c4f",
	"./promoIndex.jpg": "9017",
	"./skillsbg.jpg": "4e1e",
	"./skillsbg2.jpg": "cc9c",
	"./wqq-index.jpg": "0978",
	"./wqq-promo.jpg": "2007"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36ed";